import Locize from 'i18next-locize-backend';
import resourcesToBackend from 'i18next-resources-to-backend';

declare const IS_DEVELOPMENT: boolean;

export const i18nBackend = IS_DEVELOPMENT
  ? Locize
  : resourcesToBackend((language: string, namespace: string) => import(`locales/${language}/${namespace}.json`));

export const i18nBackendOptions = IS_DEVELOPMENT
  ? {
      projectId: process.env.NEXT_PUBLIC_LOCIZE_PROJECT_ID,
      apiKey: process.env.NEXT_PUBLIC_LOCIZE_API_KEY,
      version: process.env.NEXT_PUBLIC_LOCIZE_VERSION || 'latest',
      referenceLng: 'en',
    }
  : undefined;

export const i18nSaveMissing = false;
